import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import _TemplatedMixin from 'dijit/_TemplatedMixin';
import template from './templates/SubstituteForm.html?raw';
import topic from 'dojo/topic';
import on from 'dojo/on';
import lang from 'dojo/_base/lang';
import domStyle from 'dojo/dom-style';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
// template-instantiated child widgets (data-dojo-type) — bare side-effect imports so the loader preloads them.
import "./LangSelect";
import "../moreCore/UI/EntityBased/HintBox/HintBox";
import GenericDialog from './GenericDialog/GenericDialog';

class SubstituteForm extends compose(_WidgetBaseSP, _TemplatedMixin) {
    [key: string]: any;

    templateString: any = template;

    //translations: [],
    currentSession: any = (window as any).OpenSessionResult;
    sessionID: any = null;
    isInteractive = true;
    //sidebar: dijit.registry.byId(this._sidebarWidgetId),

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any)

        this.translations = (window as any).translations;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        //domAttr.set(this.privacy_text, "innerHTML", this.translations["Impressum__Datenschutz_Checkbox_TXT"]);
    }

    _setInteractiveAttr(bInteractive: any): void {
        if (bInteractive !== false) {
            this.isInteractive = true;
            domClass.remove(this.btnCancelSubstitution, "w3-hide");

        } else {
            this.isInteractive = false;
            domClass.add(this.btnCancelSubstitution, "w3-hide");
        }
    }


    _handleLoginResponse(response: any): void {

        //console.log("_handleLoginResponse", response, reloadLocationIfSuccessful, this.RedirectToHomeAction);

        this._setStyles();

        if (response == null) return;

        if (typeof (response.ErrorMessage) != "undefined") {
            //domAttr.set(this.node_login_error, "innerHTML", response.ErrorMessage);
            this.showMessage(response.ErrorMessage, true);
        }
    }

    showMessage(message: any, bError?: any): void {
        //console.debug("showMessage", message, bError);
        if (message == null || message == "" || typeof (message) == "undefined") {
            domClass.add(this.messageNode, "w3-hide");

            message = "";
        } else {
            domClass.remove(this.messageNode, "w3-hide");
        }

        if (bError === true) {
            domClass.add(this.messageNode, "w3-text-red");
        } else {
            domClass.remove(this.messageNode, "w3-text-red");
        }

        domAttr.set(this.messageNode, "innerHTML", message);
    }

    _setStyles(state?: any): void {
        var isSession = (window as any).sessionInfo.isSessionOpen();
        var userName = (window as any).sessionInfo.getUserName();
        var userDisplay = (window as any).sessionInfo.getUserDisplayName();
        var sessionData = (window as any).sessionInfo.sessionData;
        var employeeId = (window as any).sessionInfo.getCurrentEmployeeId();

        var actualUserName = (window as any).sessionInfo.getUserName(true);
        var actualUserDisplay = (window as any).sessionInfo.getUserDisplayName(true);
        var actualEmployeeId = (window as any).sessionInfo.getCurrentEmployeeId(true);

        domClass.add(this.selectedSubstituteInfoContainer, "w3-hide");
        domClass.add(this.selectSubstituteContainer, "w3-hide");

        if (isSession === true) {
            domClass.remove(this.domNode, "w3-hide");

            if (employeeId != actualEmployeeId) {
                domClass.remove(this.selectedSubstituteInfoContainer, "w3-hide");

                domAttr.set(this.selectedSubstituteLabel, "innerHTML", userName);
            } else {
                if (this.isInteractive === true) {
                    domClass.remove(this.selectSubstituteContainer, "w3-hide");
                }
            }

        } else {
            domClass.add(this.domNode, "w3-hide");
        }
    }

    _onKeyUp_InputLogin(e: any): void {
        if (e.keyCode == 13) {
            this.login_exec();
        } else {
            this._setLoginButtonStyle();
        }
    }

    checkForExistingSession(): void {

        var data = (window as any).sessionInfo.sessionData;

        //console.log("SubstituteForm checkForExistingSession", data);

        this._onCheckForExistingSessionResult(data);

    }

    _onCheckForExistingSessionResult(response: any): void {
        //domStyle.set(this.loginContainer, "display", "");
        var login = response;//window.lastLoginResponse;
        var state = "";


        if (login != null && typeof (login) != "undefined") {

            state = "loggedIn";
            (window as any).reload = typeof (document.getElementById("loginViewActive")) == "undefined"; //login.IsNewCreated == true; // JS2TS: 'reload' undeclared in original (leaked global) — preserved
        }

        this._setStyles(state);
        this._handleLoginResponse(response);

    }

    _onCheckForExistingSessionError(error: any): void {
        //domStyle.set(this.loginContainer, "display", "");
        console.error("_onCheckForExistingSessionError", error.Message);
    }

    _onChangeSubstitute(entity: any, evt?: any): void {
        if (entity == null || typeof (entity) == "undefined") {
            entity = this.inputSubstitute.get("value");
        }

        console.debug("_onChangeSubstitute", entity);

        if (entity != null) {
            this.askConfirmSubstitute(entity);
        }

    }

    askConfirmSubstitute(entity: any, evt?: any): void {
        var dialog = new GenericDialog();

        if (typeof ((window as any).subtitle) == "string") { // JS2TS: 'subtitle' undeclared in original (leaked global) — preserved
            dialog.set("subtitle", (window as any).subtitle);
        } else {
            dialog.hideSubtitleNode();
        }

        this.genericDialog = dialog;
        domStyle.set(dialog.textNode, "height", "unset");

        var header = this.translations["Sidebar__SelectSubstituteHeading"];
        var message = this.translations["Sidebar__SelectSubstituteMessage"];

        if (entity == null) {
            header = this.translations["Sidebar__RemoveSubstituteHeading"];
            message = this.translations["Sidebar__RemoveSubstituteMessage"];
            message = message.format((window as any).sessionInfo.getUserDisplayName());
        } else {
            message = message.format(entity.ref_vt_address_backoffice.gDisp_Name_Firstname);
        }
        dialog.set("header", header);//"Vertretung bestätigen"
        dialog.set("content", message);//"Vertretung für diese Person: " + entity.DispName);
        dialog.set("callback", lang.hitch(this, this.askConfirmSubstituteCallback, entity));

        dialog.set("ok", true);
        dialog.set("cancel", true);

        on(dialog.domNode, "click", lang.hitch(this, this._onClickDlg));

        dialog.show();
    }

    _onClickDlg(evt: any): void {
        //console.debug("_onClickDlg", evt);
        evt.stopPropagation();
    }

    _onClick_RemoveSubstitute(evt: any): void {
        if ((window as any).sessionInfo.getCurrentEmployeeId() != (window as any).sessionInfo.getCurrentEmployeeId(true)) {
            this.askConfirmSubstitute(null);
        }
    }

    askConfirmSubstituteCallback(entity: any, result: any): void {
        console.debug("askConfirmSubstituteCallback", entity, result);

        // gewählte Vertretung gehört jetzt auf die Session usw usw ...

        this.genericDialog = null;

        if (result == 1) {
            if (entity == null) {
                this._setSubstituteEmployeeRequest((window as any).sessionInfo.getCurrentEmployeeId(true), null, null, null);
            } else {
                this._setSubstituteEmployeeRequest(entity.ref_vt_address_backoffice.ID, entity.ID, entity.username, entity.ref_vt_address_backoffice.gDisp_Name_Firstname);
                this.inputSubstitute.set("value", null, true);
            }

        }
    }

    _setSubstituteEmployeeRequest(newEmployeeId: any, newUserId: any, newUsername: any, newDispname: any): void {

        var url = window.appRoot + "Home/SetSubstituteInSession";

        this.RequestManager.post(
            url,
            {
                "newEmployeeId": newEmployeeId,
                "newUserDisplayname": newDispname,
                "newUserId": newUserId,
                "newUserName": newUsername
            },
            lang.hitch(this, this._setSubstituteEmployeeResponse),
            lang.hitch(this, this._setSubstituteEmployeeError),
            false // sync
        );
    }

    _setSubstituteEmployeeResponse(response: any): void {
        this.inputSubstitute.set("value", null, true);

        location.reload();
    }

    _setSubstituteEmployeeError(error: any): void {
        // JS2TS: 'dialog' is undeclared in this method in the original (leaked global; references a
        // dialog that only exists in askConfirmSubstitute's scope) — preserved as global reads to compile.
        this.genericDialog = (window as any).dialog;
        domStyle.set((window as any).dialog.textNode, "height", "unset");

        (window as any).dialog.set("header", this.translations["Sidebar__SelectSubstituteError_Heading"]);//"Vertretung bestätigen"
        (window as any).dialog.set("content", this.translations["Sidebar__SelectSubstituteError_Message"].format(error.Message));//"Vertretung für diese Person: " + entity.DispName);

        (window as any).dialog.set("ok", true);
        on((window as any).dialog.domNode, "click", lang.hitch(this, this._onClickDlg));
        //dialog.set("cancel", true);
    }


    _setupSubscriptions(): void {
        this._topics.push(topic.subscribe("/Session/Open", lang.hitch(this, this.checkForExistingSession))); //
        this._topics.push(topic.subscribe("/Session/CheckForExistingSession", lang.hitch(this, this.checkForExistingSession)));
        //this._topics.push(topic.subscribe("/Session/Close", lang.hitch(this, this._onCloseSession)));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
        //this.checkForExistingSession();

        //this.btnLogin.innerHTML = this.translations.LoginForm__Username...
    }

}
SubstituteForm.prototype.declaredClass = 'more.SubstituteForm';

export default mdsWidget(SubstituteForm);
